const Footer = () => {
  return (
    <footer className="bg-[#7F3DFF] text-white py-4  bottom-0 mb-0">
      <div className="flex flex-col justify-between items-center">
        <div className="flex">
          <h4 className="text-3xl text-[#FCAC12]">ʛalleon</h4>
        </div>
        <p>created by </p>
        <p className="my-2">Ece Çakmak & Christian Schuermann</p>
        <p>© 2022 Galleon.</p>
        <p>All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
